import ModalContdown from 'components/ModalCountdown'
import ModalExpire from 'components/ModalExpire'
import { oauth2Agent } from 'context/AuthContext'
import { useContext, createContext, useState, useEffect, useMemo } from 'react'

const valueEmpty: unknown = {}
export const InactivityContext = createContext(valueEmpty)

interface ContextProps {
  children: React.ReactNode
}

let time: number | undefined
let timerErroModal: number | undefined
const InactivityProvider = ({ children }: ContextProps) => {
  const [visible, setVisible] = useState(false)
  const [isExpire, setIsExpire] = useState(false)
  const [newRequest, setNewRequest] = useState(false)

  const [countdown, setCountdown] = useState(6)

  useEffect(() => {
    let interval: ReturnType<typeof setTimeout>
    if (visible) {
      interval = setInterval(() => {
        if (countdown > 0) {
          setCountdown((prev) => prev - 1)
        }
      }, 1000)
    }

    return () => {
      clearInterval(interval)
    }
  }, [countdown, visible])

  const showModal = () => {
    setVisible(true)

    timerErroModal = window.setTimeout(() => {
      setIsExpire(true)
      setVisible(false)
    }, 60000)
  }

  const handleOk = () => {
    setVisible(false)
    setNewRequest(true)
    // requisição para reciclar o token

    clearTimeout(timerErroModal)
    location.reload()
  }
  const handleLogout = () => {
    oauth2Agent.logout()
  }

  const handleCancel = () => {
    setVisible(false)
    setNewRequest(false)
    handleLogout()
  }

  const resetTimer = () => {
    clearTimeout(time)
    time = window.setTimeout(showModal, 86400000)
  }

  const debounce = (func: () => void, wait: number) => {
    let timer: number | undefined
    return () => {
      clearTimeout(timer)
      timer = window.setTimeout(func, wait)
      setNewRequest(false)
    }
  }

  useMemo(() => {
    if (newRequest) resetTimer()
  }, [newRequest])

  const onHandlerRequest = () => {
    setNewRequest(true)
  }

  document.addEventListener(
    'myEventRequest',
    debounce(onHandlerRequest, 500),
    false
  )

  const valuesProvider = useMemo(() => {
    return {}
  }, [])

  return (
    <InactivityContext.Provider value={valuesProvider}>
      {children}
      {
        <>
          <ModalContdown
            countdown={countdown}
            visible={visible}
            closeModal={handleCancel}
            handleOk={handleOk}
            handleCancel={handleCancel}
          />

          <ModalExpire visible={isExpire} handleOk={handleOk} />
        </>
      }
    </InactivityContext.Provider>
  )
}

const useInactivity = () => useContext(InactivityContext)

export { InactivityProvider, useInactivity }
